import React, { PureComponent } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { push as changeLocation } from 'connected-react-router';
import PropTypes from 'prop-types';
import { Tabs, Tab, Icon } from '@blueprintjs/core';

import Toolbar from '@f/components/shared/toolbar/Toolbar';
import { Sidebar } from '@f/components/shared/sidebar';

import BatchRequestListPage from './pages/batch-search-request-list/BatchSearchRequestListPage';
import cls from './AdministrationPage.module.css';

const getRouteInfo = path => [
  {
    path: `${path}/batch-search-requests`,
    component: BatchRequestListPage,
    text: 'Searches',
    icon: 'search-around',
  },
];

class AdministrationPage extends PureComponent {
  static propTypes = {
    match: PropTypes.object,
    router: PropTypes.object,
    changeLocation: PropTypes.func,
  };

  getSelectedTabId = routeInfo => {
    const { router } = this.props;
    const { pathname } = router.location;
    return routeInfo.find(route => pathname.startsWith(route.path))?.path;
  };

  onTabChange = path => {
    this.props.changeLocation(path);
  };

  render() {
    const { match } = this.props;

    const routeInfo = getRouteInfo(match.url);
    const selectedTabId = this.getSelectedTabId(routeInfo);

    return (
      <div className={cls.page}>
        <Toolbar className={cls.toolbar}>
          <Sidebar title="Administration">
            <Tabs large fill vertical selectedTabId={selectedTabId} onChange={this.onTabChange}>
              {routeInfo.map((route, i) => {
                if (route.disabled || route.doNotShowLink) {
                  return null;
                }

                return (
                  <Tab
                    className={cls.menuTab}
                    id={route.path}
                    title={
                      <div className={cls.menuTabTitle}>
                        <Icon icon={route.icon} iconSize={Icon.SIZE_LARGE} />
                        <span>{route.text}</span>
                      </div>
                    }
                    key={String(i)}
                    data-test={route['data-test']}
                  />
                );
              })}
            </Tabs>
          </Sidebar>
          <div className={cls.toolbarContext}>
            {routeInfo.map((route, i) => {
              return <Route path={route.path} component={route.toolbarContext} key={String(i)} exact={route.exact} />;
            })}
          </div>
        </Toolbar>

        <div className={cls.body}>
          <div className={cls.content}>
            <Switch>
              {routeInfo.map((route, i) => (
                <Route path={route.path} component={route.component} key={String(i)} />
              ))}

              <Redirect to={routeInfo[0].path} />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      router: state.router,
    }),
    { changeLocation }
  )(AdministrationPage)
);
